import {JsonApiParams} from '@tisa-group/cdk';

export class LoadCompetitions {
  static readonly type = '[Competitions] Load competitions';

  constructor(readonly params?: JsonApiParams) {}
}
